var render, staticRenderFns
import script from "./loading-bar.vue?vue&type=script&lang=js&"
export * from "./loading-bar.vue?vue&type=script&lang=js&"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=15b4c7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4c7f6",
  null
  
)

export default component.exports